<template>
  <v-dialog v-model="$root.confirmAddDiaries.isVisible" persistent>
    <v-card>
      <v-toolbar class="trHeader" style="height: 40px;">
        <v-toolbar-title class="white--text" style="text-align:center;">הוספת יומנים ללקוח</v-toolbar-title>
      </v-toolbar>
      <v-flex>
        <v-card-text>הכנס את מספר היומנים שברצונך להוסיף ללוקח</v-card-text>
      </v-flex>
      <v-flex>
        <input type="number" v-model="$root.confirmAddDiaries.totalDiaries" @change="checkValue" style="width: 100px; text-align: center;" />
      </v-flex>
      <v-flex actions>
        <v-btn outline small class="green green--text ml-3" @click.native="confirmed(true)">
          שמירה
          <v-icon left>check</v-icon>
        </v-btn>
        <v-btn outline small class="red red--text ml-2" @click.native="confirmed(false)">
          ביטול
          <v-icon left>block</v-icon>
        </v-btn>
      </v-flex>
    </v-card>
  </v-dialog>
</template>

<script>

  export default {
    name: 'PopupAddDiaries',
    data() {
      return {
      }
    },
    created() {
      this.$Log("Vue [PopupAddDiaries] is created ...");
    },
    ready() {
      this.$Log("Vue [PopupAddDiaries] is ready ...");
    },
    mounted() {
      this.$Log("Vue [PopupAddDiaries] is mounted ...");
    },
    updated() {
      this.$Log("Vue [PopupAddDiaries] is updated ...");
    },
    methods: {
      confirmed(val) {
        var total = this.$root.confirmAddDiaries.totalDiaries;
        this.$root.confirmAddDiaries = {
          isVisible: false,
          totalDiaries: total,
          isConfirmed: val
        };
      },
      checkValue() {
        if (this.$root.confirmAddDiaries.totalDiaries < 1) {
          this.$root.confirmAddDiaries.totalDiaries = 1;
        }
      }
    }
  }

</script>
<style></style>



// WEBPACK FOOTER //
// PopupAddDiaries.vue?571477f0